export { default } from './StockMobileSidePanel';
